"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  root: {
    backgroundColor: theme.palette.main
  }
});

exports.default = _default;